import ReactGA from "react-ga";
ReactGA.initialize("UA-101526979-3");

export default ReactGA;
